module.exports = __webpack_public_path__ + "static/media/icono_trigo_am.c5f37d84.png";